<!-- @Description 客户案例展示组件，支持平铺与分类两种模式 -->
<template>
  <div class="customer-case">
    <template v-if="isCategorized">
      <div
        class="case-group"
        v-for="(group, gIndex) in data"
        :key="`case-group-${gIndex}`"
      >
        <div class="case-category-title">
          <span class="case-category-line" />
          <span class="case-category-text">{{ group.category }}</span>
          <span class="case-category-line" />
        </div>
        <div
          class="case-item"
          v-for="(item, index) in group.cases"
          :key="`case-item-${gIndex}-${index}`"
        >
          <div
            class="case-cover"
            v-if="!item.isplay"
            :class="{ 'is-playable': hasVideo(item) }"
            @click="play(gIndex, index)"
          >
            <img :src="item.img" alt="" />
            <div class="case-cover-overlay" v-if="hasVideo(item)">
              <span class="case-cover-play-icon" />
            </div>
          </div>
          <video
            v-else
            :src="item.video"
            controls="controls"
            class="video"
            autoplay
            controlslist="nodownload"
            webkit-playsinline="true"
            playsinline="true"
          >
            您的浏览器不支持 video 标签。
          </video>
          <div class="case-info">
            <div class="case-info-title">{{ item.title }}</div>
            <div class="case-info-content" v-html="item.content"></div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="case-item"
        v-for="(item, index) in data"
        :key="`case-item${index + 1}`"
      >
        <div
          class="case-cover"
          v-if="!item.isplay"
          :class="{ 'is-playable': hasVideo(item) }"
          @click="play(index)"
        >
          <img :src="item.img" alt="" />
          <div class="case-cover-overlay" v-if="hasVideo(item)">
            <span class="case-cover-play-icon" />
          </div>
        </div>
        <video
          v-else
          :src="item.video"
          controls="controls"
          class="video"
          autoplay
          controlslist="nodownload"
          webkit-playsinline="true"
          playsinline="true"
        >
          您的浏览器不支持 video 标签。
        </video>
        <div class="case-info">
          <div class="case-info-title">{{ item.title }}</div>
          <div class="case-info-content" v-html="item.content"></div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showVideo: false
    };
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    isCategorized: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasVideo(item) {
      return item.video && item.video !== "";
    },
    getCaseItem(groupIndex, caseIndex) {
      if (this.isCategorized) {
        return this.data[groupIndex].cases[caseIndex];
      }
      return this.data[groupIndex];
    },
    resetPlayState() {
      if (this.isCategorized) {
        this.data.forEach(group => {
          group.cases.forEach(item => {
            item.isplay = false;
          });
        });
        return;
      }
      this.data.forEach(item => {
        item.isplay = false;
      });
    },
    play(groupIndex, caseIndex) {
      const item = this.getCaseItem(
        groupIndex,
        this.isCategorized ? caseIndex : undefined
      );
      if (item.outlay) {
        window.open(item.video);
        return;
      }
      if (item.video === "") return;
      const wasPlaying = item.isplay;
      this.resetPlayState();
      item.isplay = !wasPlaying;
    }
  }
};
</script>
<style lang="less" scoped>
.customer-case {
  .case-group {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .case-category-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    margin-bottom: 24px;

    .case-category-line {
      flex: 1;
      height: 1px;
      background: #d8dce3;
    }

    .case-category-text {
      flex-shrink: 0;
      font-size: 32px;
      font-weight: 500;
      color: #08204d;
      line-height: 44px;
    }
  }

  .case-item {
    background: #ffffff;
    box-shadow: 0px 4px 12px -8px rgba(8, 32, 77, 0.25);
    border-radius: 12px;
    border: 2px solid #e6e7ed;
    text-align: center;
    padding: 16px;
    margin-bottom: 48px;
    &:last-child {
      margin-bottom: 0;
    }

    .case-cover {
      position: relative;

      &.is-playable {
        cursor: pointer;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }

      .case-cover-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.25);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .case-cover-play-icon {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;

        &::after {
          content: "";
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 12px 0 12px 20px;
          border-color: transparent transparent transparent #ffffff;
          margin-left: 4px;
        }
      }
    }

    .video {
      width: 100%;
    }

    .case-info {
      padding: 0 16px;

      .case-info-title {
        margin: 24px 0 14px;
        font-size: 32px;
        color: #08204d;
        line-height: 44px;
        text-align: left;
        font-weight: 500;
      }

      .case-info-content {
        font-size: 24px;
        font-weight: 400;
        color: #08204d;
        line-height: 40px;
        text-align: justify;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customerCase.vue